import axios from 'axios'

// 获取IP定位信息
export function getIpLocation() {
    return axios.get('https://ip.nixiaofeng.com/baidu-location')
    .then(response => {
        const { content } = response.data;
        const { status } = response.data;
        return {
            status: !status,
            province: content.address_detail.province,
            city: content.address_detail.city,
        };
    });
}

// 百度地图API相关
export function loadBaiduMapScript(ak) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.src = `https://api.map.baidu.com/api?type=webgl&v=1.0&ak=${ak}&callback=onBMapCallback`
        script.onerror = reject
        window.onBMapCallback = () => {
            resolve(BMapGL)
        }
        document.head.appendChild(script)
    })
}